<template>
    <div class="range-wrapper">
      <p>{{description}}  ({{unit}})</p>
      <p class="range"><span></span><span></span></p>
      <vue-slider  v-model="value" :min="min" :max="max" tooltip="always"/>
    </div>
</template>

<script>


import VueSlider from "vue-slider-component";
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    VueSlider
  },
  data:function (){
    return {
      gridForSelect:'col-lg-4',
    }
  },
  name: "SlideFilter",
  props: {
    property:{
      type:String,
      required:true
    }
  },

  computed: {
    min () {
      const propertyValue = this.$store.getters.filterValue(this.property);
      return propertyValue['min'];
    },
    max () {
      const propertyValue = this.$store.getters.filterValue(this.property);
      return propertyValue['max'];
    },
    description() {
      const propertyValue = this.$store.getters.filterValue(this.property);
      return propertyValue['description'];
    },
    unit() {
      const propertyValue = this.$store.getters.filterValue(this.property);
      return propertyValue['unit'];
    },
    value: {
      get: function () {
        let propertyValue = this.$store.getters.selectedValue(this.property);

        if (typeof propertyValue == 'undefined'){
          propertyValue = this.$store.getters.filterValue(this.property);

          this.$store.dispatch('select',{name:this.property,value:
             [
               propertyValue['min'],
               propertyValue['max']
             ]
          });

          return [
            propertyValue['min'],
            propertyValue['max']
          ]
        }

        return [
          propertyValue[0],
          propertyValue[1]
        ];

      },
      set: function (newValue) {
        this.$store.dispatch('select',{name:this.property,value:newValue});
      }
    }
  }
}
</script>

